var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"待处理","name":"first"}},_vm._l((_vm.arr),function(item,index){return _c('el-card',{key:index,style:({
                    width: '493px',
                    height: '119px',
                    marginTop: '10px',
                    backgroundColor: '#F9F9F9'
                }),attrs:{"shadow":"hover"}},[_vm._v(" "+_vm._s(item))])}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }